import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'itl-detail-item',
  templateUrl: './detail-item.component.html',
  styleUrls: ['./detail-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailItemComponent {
  @Input() clickAble = false;
  @Output() clicked: EventEmitter<null> = new EventEmitter<null>();

  triggerevent() {
    this.clicked.emit();
  }
}
